import React from 'react';
import HeaderCell from './HeaderCell';

class HeaderRow extends React.Component {
    render() {
        const cells = this.props.values.map((value, index) => {
            // Build Header Cell with ones and tenths place of z-score input
            return (
                <HeaderCell
                    key={index - 1}
                    column={index - 1}
                    value={value}
                />
            );
        });

        // Build Row
        return (
            <tr>{cells}</tr>
        );
    }
}

export default HeaderRow;